import React from "react";
import { Table } from "flowbite-react";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import Loader from "../../../components/Loader";

const RunModel = ({ tableRef, isChecked, testResults, loading }) => {
  if (loading) {
    return (
      <div className="w-full mt-8 text-center">
        <Loader />
      </div>
    );
  }

  // ✅ SAFE NORMALIZATION (pattern-judge compatible)
  const normalize = (str) => {
    return str
      ?.replace(/\r\n/g, "\n")    // Windows → Unix newline
      .replace(/[ \t]+$/gm, "")  // remove trailing spaces per line
      .replace(/\n+$/, "");      // remove trailing empty lines
  };

  return (
    <div className="w-full mt-8 font-poppins">
      <h4 className="mb-4 text-2xl font-semibold text-gray-800">
        Test Results:
      </h4>

      <div className="max-w-full overflow-x-auto overflow-y-hidden border border-gray-300 rounded-lg shadow-md">
        <Table ref={tableRef} className="w-full text-sm text-gray-700">
          <Table.Head className="bg-gray-100">
            <Table.HeadCell className="px-6 py-3 text-base font-semibold border">
              Input
            </Table.HeadCell>
            <Table.HeadCell className="px-6 py-3 text-base font-semibold border">
              Output
            </Table.HeadCell>

            {!isChecked && (
              <>
                <Table.HeadCell className="px-6 py-3 text-base font-semibold border">
                  Expected Output
                </Table.HeadCell>
                <Table.HeadCell className="px-6 py-3 text-base font-semibold border">
                  Result
                </Table.HeadCell>
              </>
            )}
          </Table.Head>

          <Table.Body className="bg-white">
            {testResults?.map((result, index) => {
              const inputNormalized = normalize(result.input);
              const outputNormalized = normalize(result.output);
              const expectedNormalized = normalize(result.expextedOutput);

              const isPassed = outputNormalized === expectedNormalized;

              return (
                <Table.Row
                  key={index}
                  className={`transition duration-200 ease-in-out border ${
                    index % 2 !== 0 ? "bg-gray-50" : "bg-white"
                  } hover:bg-blue-50`}
                >
                  <Table.Cell className="px-6 py-4 font-mono whitespace-pre-wrap border">
                    {inputNormalized}
                  </Table.Cell>

                  <Table.Cell className="px-6 py-4 font-mono whitespace-pre-wrap border">
                    {outputNormalized}
                  </Table.Cell>

                  {!isChecked && (
                    <>
                      <Table.Cell className="px-6 py-4 font-mono whitespace-pre-wrap border">
                        {expectedNormalized}
                      </Table.Cell>

                      <Table.Cell
                        className={`px-6 py-4 font-semibold ${
                          isPassed ? "text-green-600" : "text-red-600"
                        }`}
                      >
                        {isPassed ? (
                          <div className="flex items-center gap-2">
                            <AiOutlineCheckCircle className="text-xl" />
                            <span>Passed</span>
                          </div>
                        ) : (
                          <div className="flex items-center gap-2">
                            <AiOutlineCloseCircle className="text-xl" />
                            <span>Failed</span>
                          </div>
                        )}
                      </Table.Cell>
                    </>
                  )}
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};

export default RunModel;
